import { render, staticRenderFns } from "./PendingExpensesDonut.vue?vue&type=template&id=b64b6088"
import script from "./PendingExpensesDonut.vue?vue&type=script&lang=js"
export * from "./PendingExpensesDonut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports